export default __webpack_public_path__ + "static/media/correct5.31c6ab62.mp3";